import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function customerTeam(token: string): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('customerTeam')
    .setMethod('POST')
    .setProps([{token: token}])
    .send();
}
  